import { render } from "./BlogDetailsPage.vue?vue&type=template&id=ce253298"
import script from "./BlogDetailsPage.vue?vue&type=script&lang=js"
export * from "./BlogDetailsPage.vue?vue&type=script&lang=js"

import "./BlogDetailsPage.vue?vue&type=style&index=0&id=ce253298&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__